<h2 [class]="titleColorClass" mat-dialog-title>{{ dialogTitle }}</h2>

<mat-dialog-content class="customer-dialog-content">
    <div class="customer-info-grid">
        <div class="info-item">
            <span class="info-label">Customer Name:</span>
            <span class="info-value">{{ data.customerName }}</span>
        </div>

        <div class="info-item">
            <span class="info-label">Best Contact Number:</span>
            <span class="info-value">{{ formatPhoneNumber(data.bestContactNumber) }}</span>
        </div>

        <div class="info-item">
            <span class="info-label">Other Contact Number:</span>
            <span class="info-value">{{ formatPhoneNumber(data.otherContactNumber) }}</span>
        </div>

        <div class="info-item">
            <span class="info-label">Email:</span>
            <span class="info-value">{{ data.email }}</span>
        </div>
    </div>
</mat-dialog-content>

<mat-dialog-actions class="dialog-actions">
    <button (click)="onOpenApplication()" color="primary" mat-raised-button>
        <mat-icon>open_in_new</mat-icon>
        View app
    </button>
    <button [matMenuTriggerFor]="actionMenu" color="primary" mat-raised-button>
        <mat-icon>more_vert</mat-icon>
        Call actions
    </button>
    <mat-menu #actionMenu="matMenu">
        <button (click)="onCompleted()" mat-menu-item>
            <mat-icon>check_circle</mat-icon>
            <span>Completed</span>
        </button>
        <button (click)="onReschedule()" mat-menu-item>
            <mat-icon>schedule</mat-icon>
            <span>Reschedule</span>
        </button>
        <button (click)="onCancel()" mat-menu-item>
            <mat-icon>cancel</mat-icon>
            <span>Cancel</span>
        </button>
    </mat-menu>
    <button (click)="onClose()" mat-button>
        Close
    </button>
</mat-dialog-actions>